import { useEffect } from 'react';

import { useShortcutRegistry } from './useShortcutRegistry';

import type { ScopeRegistration } from '@src/services/shortcuts/types';

interface UseShortcutScopeOptions {
  enabled?: boolean;
}

export function useShortcutScope(
  config: ScopeRegistration,
  options: UseShortcutScopeOptions = {},
): void {
  const registry = useShortcutRegistry();
  const { enabled = true } = options;

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const unregister = registry.register(config);
    return () => unregister();
  }, [registry, enabled, config]);
}
